export default __webpack_public_path__ + "static/media/AnimalRevealSound.ada1e01d.ogg";